import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabaseInstructorStorage } from '../services/supabaseStorage';
import { Instructor } from '../types/crm';

interface InstructorState {
  instructor: Instructor | null;
  loading: boolean;
}

export function useInstructor() {
  const { user } = useAuth();
  const [instructorState, setInstructorState] = useState<InstructorState>({
    instructor: null,
    loading: true,
  });

  useEffect(() => {
    if (!user?.email) {
      setInstructorState({ instructor: null, loading: false });
      return;
    }

    const checkInstructorStatus = async () => {
      try {
        const instructor = await supabaseInstructorStorage.getInstructorByEmail(user.email);
        setInstructorState({ 
          instructor, 
          loading: false 
        });
      } catch (error) {
        console.error('Error checking instructor status:', error);
        setInstructorState({ instructor: null, loading: false });
      }
    };

    checkInstructorStatus();
  }, [user]);

  return instructorState;
}

